export const FirebaseMessage = {
  OTP_EXPIRED:
    "Firebase: The SMS code has expired. Please re-send the verification code to try again. (auth/code-expired).",
};
